import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {invalidateQueriesForUser as invalidateAlertQueriesForUser} from 'src/modules/profile/user/tabs/content/alerts/slices/alertsSlice';
import {invalidateLayoutsCount} from 'src/modules/profile/user/tabs/content/layouts/slices/layoutsCountSlice';
import {invalidateQueriesForUser as invalidateLayoutQueriesForUser} from 'src/modules/profile/user/tabs/content/layouts/slices/layoutsSlice';
import {invalidateUserLists} from 'src/modules/profile/user/tabs/content/lists/slices/listsSlice';
import {invalidateUserSearches} from 'src/modules/profile/user/tabs/content/searches/slices/searchesSlice';
import {invalidateQueriesForUser as invalidateWorkspaceQueriesForUser} from 'src/modules/profile/user/tabs/content/workspace/slices/workspacesSlice';

export const useInvalidateUserContent = (userId: number) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(invalidateUserSearches(userId));
        dispatch(invalidateUserLists(userId));
        dispatch(invalidateAlertQueriesForUser(userId));
        dispatch(invalidateWorkspaceQueriesForUser(userId));
        dispatch(invalidateLayoutQueriesForUser(userId));
        dispatch(invalidateLayoutsCount(userId));
    }, [dispatch, userId]);
};
